const containsFallbackParameter = (url) => {
  return url.includes('fallback=1');
};

const urlMatchesCurrentHost = (url) => {
  const currentUrl = new URL(window.location.href);
  const fallbackUrl = new URL(url);

  return currentUrl.host === fallbackUrl.host;
};

const isValidFallbackUrl = (url) => containsFallbackParameter(url) && urlMatchesCurrentHost(url);

export default () => {
  const searchParams = new URLSearchParams(window.location.search);
  if (!searchParams.has('fallbackUrl')) {
    return null;
  }
  const fallbackUrl = decodeURIComponent(searchParams.get('fallbackUrl'));

  return isValidFallbackUrl(fallbackUrl) ? fallbackUrl : null;
};
